export const FEATURE_FLAGS = {
  COMUNICACION_ENABLED: false,
  AI_ASSISTANT_ENABLED: true,
  WEBINARS_ENABLED: false,
  // Marca/sponsor original de Almacenia (Coca-Cola, marketplace de chapas en mercado.ñam.org).
  // Desactivado para builds white-label (ej. TiendIA/Bavaria), donde solo se muestran los puntos.
  SPONSOR_BRANDING_ENABLED: false,
};
